import { useSelector } from 'react-redux';
import {
    HStack,
    VStack,
    Progress,
    Skeleton,
    SkeletonCircle,
} from '@chakra-ui/react';
import { Card, CardBody } from 'components/v4/Card';
import styles from '../../styles';

const DashboardCardSkeleton = () => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <Card
            bg={darkMode ? 'dark.tcap' : null}
            sx={{
                minHeight: '190px',
                border: '1px solid',
                borderColor: darkMode ? 'gray.700' : 'gray.200',
                boxShadow: darkMode
                    ? 'none'
                    : '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
            }}>
            <Progress
                value={100}
                sx={styles.verticalBar}
                colorScheme="gray"
                isIndeterminate
            />
            <CardBody
                sx={{
                    display: 'flex',
                    flexDir: 'column',
                }}>
                <VStack
                    alignItems="flex-start"
                    width="100%"
                    spacing={2}
                    marginBottom="15px">
                    <HStack alignItems="flex-start" width="100%">
                        <SkeletonCircle size="50px" />
                        <VStack
                            alignItems="flex-start"
                            width="100%"
                            spacing={2}>
                            <Skeleton height="24px" width="150px" />
                            <Skeleton height="20px" width="120px" />
                            <Skeleton height="16px" width="100px" />
                        </VStack>
                    </HStack>
                </VStack>
            </CardBody>
        </Card>
    );
};

export default DashboardCardSkeleton;
